module.exports = __webpack_public_path__ + "img/check-mark-circle.7a70c3e0.svg";